// ============================================================
// Keep bike upgrades (power meter / wheelset) in sync with the
// parent bike line item:
//   1. If the bike's quantity changes, match upgrade quantities.
//   2. If the bike is removed (quantity -> 0), remove its
//      upgrades too.
//
// Hooks into Minimog's own `cart:updated` event, which fires
// after every quantity change AND every remove-button click
// (MCartRemoveButton just calls updateQuantity(index, 0), so
// it's the same event path). No need to re-fetch /cart.js or
// guess at endpoint URLs — the event already carries the fresh
// cart JSON.
//
// Append this to the bottom of bike-customization.js
// ============================================================
(function () {
	let isReconciling = false;

	document.addEventListener("cart:updated", (event) => {
		const cart = event.detail && event.detail.cart;
		if (!cart || !Array.isArray(cart.items)) return;
		reconcileBundles(cart);
	});

	async function reconcileBundles(cart) {
		if (isReconciling) return;

		// Group line items by bundle id
		const bundles = {};

		cart.items.forEach(item => {
			const bundleId = item.properties && item.properties._bundleId;
			if (!bundleId) return;

			if (!bundles[bundleId]) {
				bundles[bundleId] = { parent: null, children: [] };
			}

			const isChild = !!(item.properties && item.properties._parentKey);

			if (isChild) {
				bundles[bundleId].children.push(item);
			} else {
				bundles[bundleId].parent = item;
			}
		});

		const updates = {}; // { line_item_key: quantity }
		let needsUpdate = false;

		Object.values(bundles).forEach(({ parent, children }) => {
			if (!children.length) return;

			if (!parent) {
				// Parent bike is gone -> drop its upgrades
				children.forEach(child => {
					updates[child.key] = 0;
				});
				needsUpdate = true;
				return;
			}

			children.forEach(child => {
				if (child.quantity !== parent.quantity) {
					updates[child.key] = parent.quantity;
					needsUpdate = true;
				}
			});
		});

		if (!needsUpdate) return;

		isReconciling = true;

		try {
			const { routes } = window.MinimogSettings;

			await fetch(routes.cart_update_url, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Accept: "application/json"
				},
				body: JSON.stringify({ updates })
			});

			// Same pattern the theme itself uses to force a UI refresh
			// after a background cart change (see product-ajax:added
			// handler above).
			document.dispatchEvent(new CustomEvent("cart:refresh", {
				bubbles: true,
				detail: {}
			}));
		} catch (e) {
			console.error("Bundle reconciliation failed:", e);
		} finally {
			isReconciling = false;
		}
	}
})();
